export default __webpack_public_path__ + "static/media/personal.a5384ec2.PNG";